import React from "react";
import { Box, useTheme } from "@mui/material";
import { Activity, SquareCheck } from "lucide-react";

interface StatusBadgeCstProps {
  label: string;
  variant?: "active" | "default";
}

const StatusBadgeCst: React.FC<StatusBadgeCstProps> = ({
  label,
  variant = "active",
}) => {
  const theme = useTheme();

  const colors = {
    active: {
      bg: theme.palette.badge.success.background,
      fg: "#000000",
      border: `1px solid ${theme.palette.badge.success.border}`,
    },
    default: {
      bg: theme.palette.action.disabledBackground,
      fg: theme.palette.text.primary,
      border: "none",
    },
  }[variant];

  return (
    <Box
      sx={{
        display: "inline-flex",
        alignItems: "center",
        gap: "6px",
        padding: "4px 10px",
        borderRadius: "8px",
        backgroundColor: colors.bg,
        color: colors.fg,
        border: colors.border,
        fontSize: "12px",
        fontWeight: 600,
        lineHeight: 1.2,
      }}
    >
      {variant === "active" ? (
        <SquareCheck size={12} />
      ) : (
        <Activity size={12} />
      )}
      {label}
    </Box>
  );
};

export default StatusBadgeCst;
